import React, { FC } from 'react';
import './css/form-address-item.css';

export interface FormAddressItemProps {
  errorMessage?: string;
  label?: string;
  children?: JSX.Element;
}

const FormAddressItem: FC<FormAddressItemProps> = ({ label, errorMessage, children }): JSX.Element => {
  return (
    <div className="fa-form-item">
      {label && label.length > 0 && (<span>{label}</span>)}
      {children}
      {errorMessage && <span className="fa-form-item-error">{errorMessage}</span>}
    </div>
  )
}

export default FormAddressItem;
